import {
  Building2,
  Globe2,
  Users,
  Target,
  Gauge,
  Settings2,
  CheckCircle2,
} from "lucide-react";

const COMPANY_DETAILS_STEPS = [
  { id: 1, title: "company_info", icon: Building2 },
  { id: 2, title: "business_profile", icon: Globe2 },
  { id: 3, title: "size_revenue", icon: Users },
  { id: 4, title: "markets_objectives", icon: Target },
  { id: 5, title: "ghg_emission_baseline", icon: Gauge },
  // { id: 6, title: "summary", icon: CheckCircle2 },
];

export const GHG_BASELINE_STEP_ID = 5;

// Step ids stay fixed (System Settings = 6, Summary = 6/7) so the GHG step is
// hidden by omission, not renumbering. Only companies with
// `ghgBaselineEnabled` get it.
export const getCompanySteps = (
  showSystemSettings = false,
  showGhgBaseline = false,
) => [
  ...COMPANY_DETAILS_STEPS.filter(
    ({ id }) => showGhgBaseline || id !== GHG_BASELINE_STEP_ID,
  ),
  ...(showSystemSettings
    ? [{ id: 6, title: "system_settings", icon: Settings2 }]
    : []),
  {
    id: showSystemSettings ? 7 : 6,
    title: "summary",
    icon: CheckCircle2,
  },
];

// Last "details" step before System Settings / Summary.
export const getLastDetailsStep = (showGhgBaseline = false) =>
  showGhgBaseline ? GHG_BASELINE_STEP_ID : GHG_BASELINE_STEP_ID - 1;

// Neighbouring step id, hopping over the GHG step when it is hidden.
export const getAdjacentStep = (step, direction, showGhgBaseline = false) => {
  const target = step + direction;
  return !showGhgBaseline && target === GHG_BASELINE_STEP_ID
    ? target + direction
    : target;
};
